
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 14","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"1.5","cy":"12.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"1.5","cy":"7","r":"1.5"}}),_c('circle',{attrs:{"cx":"6.5","cy":"12.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"6.5","cy":"7","r":"1.5"}}),_c('circle',{attrs:{"cx":"6.5","cy":"1.5","r":"1.5"}})])
          )
        }
      }
    